module.exports = __webpack_public_path__ + "img/gb818-85_m4.prt.c1928696.jpg";